import React from "react";

// Define the props interface
interface ConstructionMessageProps {
  code:string,
  description: string; // Message content (HTML string)
  propscode:string
  show:boolean
}

// Component to display the construction message
const ConstructionMessage: React.FC<ConstructionMessageProps> = ({
  code,
  description,
  propscode,
  show
  
}) => {
 
  return (
    <>
      {show && String(propscode).toLowerCase() === String(code).toLowerCase() && (
        <div dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </>
  );
};

export default ConstructionMessage;
